import React from "react";
import { useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { Button } from "./ui/button";
import { useStore } from "../context/StoreContext";
import { money } from "../lib/api";

export default function CartDrawer() {
  const { cart, cartOpen, setCartOpen, setQty, cartSubtotal } = useStore();
  const navigate = useNavigate();

  return (
    <Sheet open={cartOpen} onOpenChange={setCartOpen}>
      <SheetContent side="right" className="bg-[#0d0d0d] border-white/10 w-full sm:max-w-md flex flex-col" data-testid="cart-drawer">
        <SheetHeader>
          <SheetTitle className="font-display text-xl text-gold">Seu carrinho</SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto py-6 flex flex-col gap-5">
          {cart.length === 0 && (
            <p className="text-sm text-zinc-500 text-center py-12" data-testid="cart-empty">Seu carrinho está vazio.</p>
          )}
          {cart.map((item) => (
            <div key={`${item.product_id}:${item.variation_id}`} className="flex gap-4" data-testid={`cart-item-${item.sku || item.variation_id}`}>
              <div className="w-20 h-20 rounded-md overflow-hidden bg-white/5 shrink-0">
                {item.image && <img src={item.image} alt={item.name} className="w-full h-full object-cover" loading="lazy" />}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-zinc-100 truncate">{item.name}</p>
                <p className="text-xs text-zinc-500">{item.variation_name}</p>
                <p className="text-sm text-gold mt-1">{money(item.price)}</p>
                <div className="flex items-center gap-2 mt-2">
                  <button data-testid="cart-qty-minus" onClick={() => setQty(item.product_id, item.variation_id, item.quantity - 1)}
                    className="p-1 border border-white/15 rounded hover:border-gold hover:text-gold transition-colors" aria-label="Diminuir">
                    <Minus size={13} />
                  </button>
                  <span className="text-sm w-6 text-center" data-testid="cart-item-qty">{item.quantity}</span>
                  <button data-testid="cart-qty-plus" onClick={() => setQty(item.product_id, item.variation_id, item.quantity + 1)}
                    className="p-1 border border-white/15 rounded hover:border-gold hover:text-gold transition-colors" aria-label="Aumentar">
                    <Plus size={13} />
                  </button>
                  <button data-testid="cart-remove-item" onClick={() => setQty(item.product_id, item.variation_id, 0)}
                    className="ml-auto p-1 text-zinc-500 hover:text-red-400 transition-colors" aria-label="Remover">
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {cart.length > 0 && (
          <div className="border-t border-white/10 pt-5 pb-2">
            <div className="flex justify-between mb-5">
              <span className="text-sm text-zinc-400">Subtotal</span>
              <span className="font-display text-lg text-gold" data-testid="cart-subtotal">{money(cartSubtotal)}</span>
            </div>
            <Button
              data-testid="go-to-checkout-button"
              className="w-full bg-gold text-black hover:bg-gold-light font-semibold transition-colors"
              onClick={() => { setCartOpen(false); navigate("/checkout"); }}
            >
              Finalizar compra
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
